import { useState, useEffect } from "react";
import { BoldifyReplace } from "../BoldifyReplace";

const BookSection = ({ content, label, page, autoOpen = false, cKey = "", bottom, handleSelectCreature}) => {
    const [isOpen, setIsOpen] = useState(autoOpen);
    const [firstOpen, setFirstOpen] = useState(true);

    const toggleOpen = () => setIsOpen(open => !open);

    useEffect(() => {
        // If section is opened save it
        if (isOpen) {
            localStorage.setItem(`booksection-${cKey}.${label}`, true);
        } else {
            // secton closed - if first load check if it should be opened
            if(firstOpen) {
                const isSaved = localStorage.getItem(`booksection-${cKey}.${label}`);
                if(isSaved)
                    toggleOpen()

                setFirstOpen(false);
            } else { // if closed on subsequent loads, remove from storage
                localStorage.removeItem(`booksection-${cKey}.${label}`);
            }
        }
    }, [isOpen]);
    
    return (
        <li className='bookSectionItem' key={cKey}>
            {label && 
                <div className='bookListContainer bookListEntry' onClick={toggleOpen} 
                    style={{
                        borderBottom: bottom ? '2px solid black' : '',
                        marginBottom: bottom ? '3px' : '0px'
                    }} 
                >
                    <b>{label}</b> 
                    <div style={{cursor: 'pointer'}}>
                        {page && <i style={{fontSize: "small", marginRight: "5px"}}>p.{page}</i>}
                        <svg width="16" height="16" viewBox="0 0 16 16" style={{
                            verticalAlign: "middle",
                            transition: "transform 0.2s",
                            transform: isOpen ? "rotate(0deg)" : "rotate(90deg)"
                        }}>
                            <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
            }
            <ul className='bookListUL'>
                {isOpen && content.map((entry, idx) => {
                    let bottomEntry = idx === content.length - 1;
                    let cKeyTag =  `${cKey}.${label}.${entry.type}.${idx}`
                    if (typeof entry === 'string') {
                        return (
                            <li className="bookListEntry" key={cKeyTag}
                                style={{
                                    borderBottom: bottomEntry ? '3px solid black' : 'none',
                                    marginBottom: bottomEntry ? '5px' : '0px'
                                }}
                            >
                                <BoldifyReplace desc={entry} handleSelectCreature={handleSelectCreature}/>
                            </li>
                        );
                    } else if (typeof entry === 'object') {
                        if (entry.type === 'image') {
                            return (
                                <li className="bookListEntry bookListEntryImage" key={cKeyTag}
                                    style={{
                                        borderBottom: bottomEntry ? '5px solid black' : 'none',
                                        marginBottom: bottomEntry ? '5px' : '0px'
                                    }}
                                >
                                    {entry.title && <div style={{color: "black"}}><i>{entry.title}</i></div> }
                                    <img src={'https://5e.tools/img/' + entry.href.path} 
                                        width={100} height={100} alt={`${'Image: https://5e.tools/img/' + entry?.href?.path}`}
                                        onClick={() => window.open('https://5e.tools/img/' + entry.href.path, '_blank')}
                                        style={{ cursor: 'pointer', outline: '1px solid black' }}
                                    />
                                    {entry.credit && <div style={{color: "black", fontSize: "small"}}><i>Image Credit: {entry.credit}</i></div>}
                                </li> 
                            );
                        } else if (['section', 'inset', 'entries', 'inset', 'insetReadaloud', 'quote', 'item'].includes(entry.type)) {
                            return <BookSection key={cKeyTag} content={entry.entries} label={entry.name} page={entry.page} autoOpen={!!!entry.name} cKey={cKeyTag} bottom={bottomEntry} handleSelectCreature={handleSelectCreature}/>
                        } else if (entry.type === 'list') {
                            return <BookSection key={cKeyTag} content={entry.items} page={entry.page} autoOpen={true} cKey={cKeyTag} bottom={bottomEntry} handleSelectCreature={handleSelectCreature}/>
                        } else if (entry.type === 'gallery') {
                            return <BookSection key={cKeyTag} content={entry.images} page={entry.page} cKey={cKeyTag} bottom={bottomEntry} handleSelectCreature={handleSelectCreature}/>
                        }  
                        else if (entry.type === "table") {
                            return (
                                <table className='spellTable'>
                                    {entry.colLabels &&
                                        <tr>
                                            {entry.colLabels.map((label) => {
                                                return <th><BoldifyReplace desc={label} handleSelectCreature={handleSelectCreature}/></th>
                                            })}
                                        </tr>
                                    }
                                    {entry.rows.map((row) => {
                                        return (
                                            <tr>
                                                {row.map((rowData, index) => {
                                                    return <td className={index ? "" : "spellTableDice"}><BoldifyReplace desc={rowData} handleSelectCreature={handleSelectCreature}/></td>
                                                })}
                                            </tr>
                                        )
                                    })}
                                </table>
                            )
                        } else {
                            return <b>If you are seeing this let nic know on discord :)</b>
                        }
                        
                    } else {
                        return null;
                    }
                })}
            </ul>
         
        </li>
    );
};

export default BookSection;